import { faEnvelopeCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";

export default function EmailNotificationUser({ setCurrentRoute }) {
  const navigate = useNavigate();

  const handleLogin = () => {
    setCurrentRoute("login");
    navigate("/login");
  };

  return (
    <div className="row login-start login-page-shell">
      <div className="col-12">
        <div className="login-layout login-layout--centered">
          <section className="login-form-panel login-form-panel--centered auth-flip-card glass-panel setting-login auth-stack-panel">
            <div className="auth-notice-icon">
              <FontAwesomeIcon icon={faEnvelopeCircleCheck} />
            </div>
            <div className="login-form-header">
              <p className="login-form-eyebrow">Request submitted</p>
              <p className="login-form-subtitle">
                Your subscription request has been sent to an admin for review.
                After approval, you will receive a confirmation email and can
                sign in normally.
              </p>
            </div>

            <div className="login-action-stack">
              <button
                className="simple-btn login-btn form-hidden login-submit-btn"
                onClick={handleLogin}
                type="button"
              >
                Go to login
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
